/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.MyProfile.Samples.LikedSample.Headline';
export const Body = 'Website.MyProfile.Samples.LikedSample.Body';
export const AddedToBasket = 'Website.MyProfile.Samples.LikedSample.AddedToBasket';
